export type RigaMonthKey = string & { readonly __rigaMonthKey: unique symbol }

const MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/
const SHORT_MONTH_LABELS = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сент', 'окт', 'ноя', 'дек'] as const

export function rigaMonthKey(value: string): RigaMonthKey {
  if (!MONTH_PATTERN.test(value)) throw new RangeError('month identity must use YYYY-MM')
  return value as RigaMonthKey
}

export function formatRigaMonth(month: RigaMonthKey, short = true): string {
  if (short) return `${SHORT_MONTH_LABELS[Number(month.slice(5, 7)) - 1]} ${month.slice(2, 4)}`
  return new Intl.DateTimeFormat('ru-RU', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(`${month}-01T00:00:00Z`)).replace('.', '')
}
